<template>
    <div>
        <el-card>
            <div>
                <p><b>说明</b></p>
                <p><span class="titleColod"></span>
                 <span class="titleColod">序列:</span>根据个人工单总数从多到少的规则排序；
                 <span class="titleColod">人员姓名:</span> 服务台、一线、二线、三线所有人员；
                 </p>
                 <p>
                 <span class="titleColod">工单总数:</span>事件数+问题数+变更数+发布数的总和统称工单数；
                 <span class="titleColod">解决数:</span>处理完成的数量；
                </p>
                 <p><span class="titleColod">完成率:</span>解决的数量 / 总工单数量；
                 <span class="titleColod">工时:</span>解决工单的耗费时间；</p>
                 <p>
                 <span class="titleColod">处理超时 SLA数:</span>超出规定时间范围，处理工单即为超时；
                 <span class="titleColod">处理超时 SLA率:</span>超出数 / 事件总数；
                 </p>
                 <p>
                 <span class="titleColod">其他:</span>运维 SLA 结束评判标准，转交给三线；转交给第三方；处理完成，都视为结束。

                </p>
            </div>
        </el-card>
        <el-card class="search-form-card">
            <el-form :inline="true" :model="form" class="search-form">
                <el-row>
                    <el-col :span="4">
                        <el-form-item label="服务组:">
                            <el-select v-model="form.service_group" placeholder="请选择" class="common-input">
                                <!-- <el-option label="全部" value=""></el-option> -->
                                <el-option v-for="item in serviceGroupList" :key="item.ename" :label="item.cname"
                                           :value="item.ename"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="日期:">
                            <el-date-picker
                                v-model="createTime"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item>
                            <el-button type="primary" @click="loadData">查询</el-button>
                            <el-button type="primary" @click="reset">重置</el-button>
                            <el-button @click="exportTable('personStatis','人员统计')" type="primary">导出表格</el-button>
                             <router-link :to="{ path: '/nonWorkOrderDetail',
                                     query: { callback:request }}">
                                <el-button type="primary">录入工时</el-button>
                            </router-link>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
        </el-card>
        <el-card>
           <!--  <div slot="header">
                <router-link  :to="{ path:'/problemAdd',query: { callback:request } }">

                    <el-button type="primary" v-w-role="'ITSM-0081'" >创建</el-button>
                </router-link>
            </div> -->
            <el-table :data="tableData" v-loading="loading" id="personStatis">
                <el-table-column label="序列" width="70" align="center" fixed>
                    <template slot-scope="scope">
                        <!-- <span v-if="form.pageSize===10"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*20 : scope.$index+1}}</span> -->
                        <span> {{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <!-- 点击打开oa工时列表 -->
                <el-table-column label="人员姓名" prop="user_cname" fixed align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="hoverBtn" @click="oaDialogEvent(scope.row.internal_userid,createTime,)">{{scope.row.user_cname}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="工单总数" prop="total_count" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row,'工单','total')">{{scope.row.total_count}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="解决数" prop="solve_count" align="center">
                    <template slot-scope="scope">
                        <!-- <router-link :to="{ path: '/workSheetDetail',
                                     query: { message:'解决工单',val:'solve' }}">
                            <el-button type="text" class="hoverBtn">{{scope.row.solve_count}}</el-button>
                        </router-link> -->
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row,'解决工单','solve')">{{scope.row.solve_count}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="未解决数" prop="unsolved_count" align="center">
                    <template slot-scope="scope">
                        <!-- <router-link :to="{ path: '/workSheetDetail',
                                     query: { message:'解决工单',val:'solve' }}">
                            <el-button type="text" class="hoverBtn">{{scope.row.solve_count}}</el-button>
                        </router-link> -->
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row,'未解决工单','unsolved')">{{scope.row.unsolved_count}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="完成率" prop="solve_rate" align="center"></el-table-column>
                <el-table-column label="工时总数（小时）" prop="total_work_time" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.total_work_time}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="工单工时数（小时）" prop="order_work_time" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row,'工时','work_time')" align="center">{{scope.row.order_work_time}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="非工单工时数（小时）" prop="no_order_work_time" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/nonWorkOrder',
                                     query: {usereName:scope.row.internal_userid, timeSearch:createTime,callback:request}}">
                            <el-button type="text" class="hoverBtn">{{scope.row.no_order_work_time}}</el-button>
                        </router-link>
                    </template>
                </el-table-column>
                <el-table-column label="处理超时 SLA 数" prop="yw_overtime_count" align="center">
                     <template slot-scope="scope">
                       <!--  <router-link :to="{ path: '/workSheetDetail',
                                     query: { message:'运维超时处理 SLA 数',val:'yw_overtime' }}">
                            <el-button type="text" class="hoverBtn">{{scope.row.yw_overtime_count}}</el-button>
                        </router-link> -->
                        <el-button type="text" class="hoverBtn" @click="goDetail(scope.row,'超时处理 SLA 数','yw_overtime')">{{scope.row.yw_overtime_count}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="处理超时 SLA 率" width="110" prop="yw_overtime_rate" align="center">
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog title="oa工时列表" :visible.sync="oaDialogVisible" width="80%">
            <el-button type="primary" @click="downLoad">导出</el-button>
          <el-table :data="oaTableData" max-height="500">
            <el-table-column property="date" label="序列" width="80">
                <template slot-scope="scope">
                    <span> {{scope.$index+1}}</span>
                </template>
            </el-table-column>
            <el-table-column property="worker_cname" label="姓名" width="200"></el-table-column>
            <el-table-column property="project_name" label="项目"></el-table-column>
            <el-table-column property="work_date" label="日期"></el-table-column>
            <el-table-column property="work_time_type" label="时间类型"></el-table-column>
            <el-table-column property="time_length_h" label="工作时长（小时）"></el-table-column>
            <el-table-column property="job_content" label="工作内容"></el-table-column>
            <el-table-column property="serial_number" label="工单编号"></el-table-column>
          </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import services from "./personStatis.service";
    import Config from "../../../app.config";
    const baseURL = Config.baseURL;
    // import commonService from "../../services/common.service";
    export default {
        data() {
            return {
                form:{
                    service_group:"reception",
                    start_date:'',
                    end_date:'',
                },
                tableData:[],
                oaTableData:[],
                baseURL,
                dialogForm:{},
                loading:true,
                serviceGroupList:[],     // 问题分类
                createTime:[],
                oaDialogVisible:false,
            }
        },
        created() {

            this.request();
            this.getServiceGroupList();
        },
        computed:{
            // dictionary(){
            //     return this.$store.state.dictionary;
            // },

        },
        methods: {
            exportTable(id,name,startTime='',endTime=''){
                this.$exportTable(id,name,startTime,endTime)
            },
            // 获取服务组
            getServiceGroupList(){
                services.getServiceGroup().then(res => {
                    // console.log(res)
                    this.serviceGroupList = res
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            oaDialogEvent(worker,searchTime){
                // console.log(worker)
                // console.log(searchTime)
                this.dialogForm={
                    worker:worker,
                    start_date: searchTime.length>0 ? searchTime[0]:'',
                    end_date: searchTime.length>0 ? searchTime[1]:'',
                }
                this.oaDialogVisible = true
                services.getOaTimeList(this.dialogForm).then(res => {
                    // console.log(res)
                    this.oaTableData = res.list
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            //导出
            downLoad(){

                let obj = this.dialogForm
                let url = `${this.baseURL}user_statistics/all_order/export_oa_work_time?worker=${obj.worker}&start_date=${obj.start_date}&end_date=${obj.end_date}`
                // console.log(url)
                let a = document.createElement('a');
                // a.setAttribute("download",'event');
                a.setAttribute("href", url);
                a.click();
                // document.remove('a')
            },
            goDetail(row,msg,val){
                // console.log(msg)
                this.$router.push({
                  path: '/workSheetDetail',
                  query: {
                    message: msg,
                    category:val,
                    internal_userid:row.internal_userid,
                    start_date:this.form.start_date,
                    end_date:this.form.end_date
                  }
                })

            },
            loadData(){
                this.loading = true;
                this.form={
                    ...this.form,
                    start_date: this.createTime[0],
                    end_date:this.createTime[1]
                }
                // console.log(this.form);
                this.request();
            },
            //重置
            reset(){
                this.form={
                    service_group:"reception",
                    start_date:'',
                    end_date:'',
                }

                this.createTime=[]
            },
            request(){
                // 获取列表数据
                // this.tableData = [];
                services.getList(this.form).then(res => {
                    this.tableData = res;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
.hoverBtn{
    :hover{
        // font-size:18px;
    }
    padding:10px 30px;

}
.titleColod{
    color:#0099FF;
}
p{
    line-height: 20px;
}
</style>
